import { CLEAR_BACKUP, RESTORE_BACKUP, SET_BACKUP } from "../../helpers/constants";

const actions = [SET_BACKUP, RESTORE_BACKUP, CLEAR_BACKUP] as const;

type AnyAction = { type: string };

type BackupAction<TState> = AnyAction & ({ backup: (keyof TState)[] })

export default function withBackup<TState, TAction extends AnyAction | BackupAction<TState>>(
  reducer: (state: TState | undefined, action: TAction) => TState,
  [SET, RESTORE, CLEAR] = actions
): (state: TState | undefined, action: TAction) => TState {
  const history: Partial<TState>[] = [];
  // eslint-disable-next-line default-param-last
  return (state = reducer(undefined, {} as TAction), action): TState => {
    switch (action.type) {
      case SET_BACKUP: {
        const backup = (action as { backup: (keyof TState)[] }).backup.reduce<Partial<TState>>((obj, key) => ({
          ...obj,
          [key]: state[key],
        }), {});
        history.push(backup);
        return state;
      }
      case RESTORE_BACKUP: {
        const backup = history.pop() || {};
        return {
          ...state,
          ...backup,
        };
      }
      case CLEAR_BACKUP: {
        history.pop();
        return state;
      }
      default:
        return reducer(state, action);
    }
  };
};
